var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckBox1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "var(--input)",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 20,
    height: 20,
    rx: 4.5,
    fill: "var(--input)",
    stroke: "var(--input-border)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.30566 9.24023L8.2572 14.0435C8.61711 14.6292 9.44704 14.6855 9.88273 14.1537L16.3663 6.24023",
    stroke: "var(--input-border)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBox1);
export default __webpack_public_path__ + "static/media/checkBox1.f3a56ee6927bc2c50dc79c133d88eee8.svg";
export { ForwardRef as ReactComponent };